export enum STORE_MODULES {
    ORDER = 'Order',
    TOASTS = 'Toasts',
}
